<script setup lang="ts">

</script>

<template>
    <div class="title-container">
        <div class="utility-left">
            <h1>911</h1>
        </div>
        <div class="utility-right">
            <h1>Non-911</h1>
        </div>
    </div>
</template>


<style scoped>
    .title {
        margin: 0;
        color: #FFCB05;
    }
    .site {
        padding: 2px;
    }
    .title-notch {
        padding-top: 65px;
        background-color: #343a40;
        color: white;
        width: 30%;
        border-radius: 50px;
        text-align:center;
    }
    .title-container {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        text-align: center;
        width: 100%;
        position: fixed;
        z-index: 10;
        background-color: white;
        padding-top: 5%;
        /* border-bottom: 1px solid #343a40; */
    }

    .utility-left {
        align-self: end;
        width: 50%;
        position: relative;
        margin: -5px;
    }
    .utility-right {
        align-self: end;
        width: 50%;
        position: relative;
        margin: -5px;
    }
</style>